import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {WindowRefService} from '../window.service';
import {AbstractService} from '../abstract.service';
import {LocalStorageService, SessionStorageService} from 'angular-web-storage';
import {StateEvent} from './state-event.model';

@Injectable()
export class StateService extends AbstractService {

  /**
   * Window instance, injected via service for mocking
   */
  public _window: any;

  private stateSubject = new BehaviorSubject<StateEvent>(new StateEvent('', null));
  public state$ = this.stateSubject.asObservable();

  constructor(private windowRef: WindowRefService, local: LocalStorageService, session: SessionStorageService) {
    super(local, session);
    this._window = windowRef.nativeWindow;
    this.name = 'StateService';
  }

  public resetState() {
    this.clearLocal();
    this._window.location.reload();
  }

  public getStateEntriesAsString() {
    const values = [];
    for (const key of Object.keys(localStorage).filter(o => o.includes('REGO_STATE_'))) {
      if (!key.startsWith('REGO_StateService_REGO_STATE_ElementInfo')) {
        values.push({key: key, value: this.getDirectLocal(key)});
      }
    }
    for (const homePanel of this.getPartOfState('Home').visiblePanels) {
      const key = 'REGO_SidebarService_' + homePanel;
      values.push({key: key, value: this.getDirectLocal(key)});
    }
    return JSON.stringify(values);
  }

  public reloadState(entries: [{ key: string, value: any }]) {
    for (const entry of entries) {
      this.setDirectLocal(entry.key, entry.value);
    }
  }

  public updateState(key: string, value: any) {
    this.stateSubject.next(new StateEvent(key, value));
    this.setLocal('REGO_STATE_' + key, value);
  }

  public removePartOfState(key: string): void {
    this.removeLocal('REGO_STATE_' + key);
  }

  public getPartOfState(key: string) {
    let s = this.getLocal('REGO_STATE_' + key);
    if (!s) {
      switch (key) {
        case 'mapState':
          s = {
            currentFeature: null,
            pitch: 0,
            bearing: -0,
            layers: null,
            streetViewEnabled: false
          };
          break;
        case 'settingsState':
          s = {
            language: 'fi',
            fontSize: 'Normal',
            screenMode: 0
          };
          break;
        case 'mapFilters':
          s = new Map<number, boolean>();
          break;
        case 'Home':
          s = {
            visiblePanels: [],
            sidebarHidden: true,
            activePanel: ''
          };
          break;
      }
      this.setLocal('REGO_STATE_' + key, s);
    }
    return s;
  }
}
